import React, { createContext, useContext, useState } from 'react';

interface SessionLoadingContextType {
  isSessionLoading: boolean;
  startSessionLoading: () => void;
  stopSessionLoading: () => void;
}

const SessionLoadingContext = createContext<SessionLoadingContextType | undefined>(undefined);

export const useSessionLoading = () => {
  const context = useContext(SessionLoadingContext);
  if (!context) {
    throw new Error('useSessionLoading must be used within a SessionLoadingProvider');
  }
  return context;
};

export const SessionLoadingProvider = ({ children }: { children: React.ReactNode }) => {
  const [isSessionLoading, setIsSessionLoading] = useState(false);

  const startSessionLoading = () => {
    setIsSessionLoading(true);
  };

  const stopSessionLoading = () => {
    setIsSessionLoading(false);
  };

  const value = {
    isSessionLoading,
    startSessionLoading,
    stopSessionLoading
  };

  return (
    <SessionLoadingContext.Provider value={value}>
      {children}
    </SessionLoadingContext.Provider>
  );
};
